<template>
    <div class="content">
        <template
            v-for="module in modules"
        >
            <Compmonent
                v-if="module.type != 'ImageModule'"
                :key="module.id"
                :is="module.type"
                :moduleId="module.id"
                :class="`module-${module.type}`"

                :module="module"
            />
        </template>

        <slot />


        <Overlay name="material-gallery" :hideClose="true">
            <MaterialGallery
                :image="images[currentImageIndex]"
                :id="currentImageIndex"
                :isFirst="isFirstImage"
                :isLast="isLastImage"
                @next="next"
                @prev="prev"
            />
        </Overlay>
    </div>
</template>

<script>
import TextModule      from '~/components/case/TextModuleNew.vue';
import EmbedModule     from '~/components/case/EmbedModuleNew.vue';
import ImageModule     from '~/components/case/ImageModuleNew.vue';
import Overlay         from '~/components/overlays/Overlay.vue';
import MaterialGallery from '~/components/overlays/MaterialGallery.vue';

export default {
    components: {
        TextModule,
        EmbedModule,
        ImageModule,
        Overlay,
        MaterialGallery
    },

    props: ['modules'],

    data () {
        return {
            currentImageIndex: 0
        }
    },

    computed: {
        isLastImage () {
            return this.currentImageIndex >= this.images.length - 1;
        },

        isFirstImage () {
            return this.currentImageIndex <= 0;
        },

        images () {
            if (!this.modules) return [];

            let images = this.modules.filter(module => module.type == 'image-module');

            return images.map(module => {
                let filePath = module.src.split('/');
                return {name: filePath[filePath.length - 1]}
            })
        }
    },

    methods: {
        openGallery (event) {
            if (!event.target || !event.target.src) return;

            let filePath  = event.target.src.split('/');
            let imageName = filePath[filePath.length - 1];

            let index = this.images.findIndex(image => image.name == imageName);

            if (index < 0) return;

            this.currentImageIndex = index;
            this.$modalityStore.openModal({type: 'overlay', name: 'material-gallery'});

            event.target.blur();
            document.getElementById('main-app').click();
        },

        next () {
            if (typeof this.currentImageIndex == 'undefined') return this.currentImageIndex = 0;

            if (this.currentImageIndex >= this.images.length -1) {
                return this.currentImageIndex = this.images.length - 1;
            }

            document.getElementById('cases-overlay').scrollTop = 0;
            this.currentImageIndex++;
        },

        prev () {
            if (typeof this.currentImageIndex == 'undefined') return this.currentImageIndex = 0;
            if (this.currentImageIndex <= 0) return this.currentImageIndex = 0;

            document.getElementById('cases-overlay').scrollTop = 0;
            this.currentImageIndex--;
        },
    }
}
</script>

<style lang="scss" scoped>
    .content .module-text-module {
        margin-right: auto;
        margin-left:  auto;

        max-width: 680px;
    }

    .content {
        .module-embed-module {
            margin-right: 16px;
            margin-left:  16px;

            @media screen and (min-width: 768px) {
                margin-right: 0;
                margin-left:  0;

                &.text {
                    margin-right: auto;
                    margin-left:  auto;
                }
            }
        }

        .module-text-module + .module-image-module.full {
            margin-top: 24px;
        }

        .module-image-module,
        .module-embed-module {
            margin-top:    56px;
            margin-bottom: 56px;
        }

        .module-image-module.full {
            margin-top:    0;
            margin-bottom: 0;

            + .module-text-module {
                margin-top: 24px;
            }
        }
    }
</style>
